import React from 'react'
import { Card } from './card'
import { KhubMap } from '../../../components'
import { Link } from 'react-router-dom'
import styleModule from './organization.module.css'

// When integrated with API, get this data from database
const mapData = [
  {
    name: 'Peacegen Indonesia',
    id: 'peacegen-indonesia',
    type: 'place',
    coordinate: {
      lat: -6.945979,
      lng: 107.626622,
    },
    markerType: 'headquarter',
    content: '<div class="border-b border-solid mb-2 pb-2">NGO / Headquarter</div><p>Jl. Cijagra, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40265</p>',
  },
  {
    name: 'CSO Sample 1',
    id: 'cso-sample-1',
    type: 'headquarter',
    coordinate: {
      lat: -7.931037,
      lng: 112.638990,
    },
    markerType: 'organization',
    content: '<div class="border-b border-solid mb-2 pb-2">CSO</div><p>Lorem ipsum dolor sit amet</p>',
  }
]

const Organization = ({className}) => {
  return (
    <Card className={className}>
      <div className="flex justify-between mb-4">
        <div className="flex">
          <h1 className="font-primary font-bold lg:text-lg mr-8">Organization</h1>
          <div className="hidden lg:flex">
            <div className="px-4 text-center">
              <p className="text-xs">Inisiatif</p>
              <p className="text-2xl">21</p>
            </div>
            <div className="px-4 text-center">
              <p className="text-xs">Produk</p>
              <p className="text-2xl">192</p>
            </div>
            <div className="px-4 text-center">
              <p className="text-xs">Event</p>
              <p className="text-2xl">5,213</p>
            </div>
            <div className="px-4 text-center">
              <p className="text-xs">Blog</p>
              <p className="text-2xl">17</p>
            </div>
          </div>
        </div>
        <Link to="/dashboard/profile" className="text-primary underline text-xs lg:text-sm">Organization Profile</Link>
      </div>
      <div className="-mx-5 -mb-5">
        <KhubMap
          data={mapData}
          mapStyleColor="light"
          mapClassName={styleModule.map}
        />
      </div>
    </Card>
  )
}

export { Organization }
